<template>
    <div class="help-widget">
        <h3 class="help-widget__title">{{ title }}</h3>
        <div class="help-container">
            <div class="help-item">
                <help-item
                    :item-data="faqItem"
                />
                <help-item
                    :item-data="forumItem"
                />
            </div>
            <div class="help-delimiter" />
            <div class="help-item">
                <help-with-switch-item
                    ref="HelpWithSwitchItem"
                    :item-data="supportItem"
                />
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
    import { Strings } from "@/locales/types/enums/strings";
    import type { IHelpItem } from './types/help';
    import HelpItem from './components/HelpItem.vue';
    import { useI18n } from "vue-i18n";
    import FaqIcon from "./components/Icons/FaqIcon.vue";
    import ForumIcon from "./components/Icons/ForumIcon.vue";
    import SupportIcon from "./components/Icons/SupportIcon.vue";
    import { useHelpStore } from "@/stores/Help";
    import { storeToRefs } from 'pinia';
    import { computed, type ComputedRef, onUnmounted } from 'vue';

    const HelpStoreModule = useHelpStore();
    const {
        getFaq,
        getForum
    } = storeToRefs(HelpStoreModule);
    const { clearHelp } = HelpStoreModule;
    

    const { t } = useI18n();
    const title = t(Strings.SETTINGS_NAVIGATION_HELP).toString();
    const faqItem: ComputedRef<IHelpItem> = computed(() => ({
        iconComponent: FaqIcon,
        title: t(Strings.SETTINGS_HELP_FIZZ_FAQ_TITLE).toString(),
        description: t(Strings.SETTINGS_HELP_FIZZ_FAQ_DESCRIPTION).toString(),
        link: getFaq.value.link,
        url: getFaq.value.url,
        visit: t(Strings.SETTINGS_HELP_FIZZ_VISIT).toString()
    }));
    const forumItem: ComputedRef<IHelpItem> = computed(() => ({
        iconComponent: ForumIcon,
        title: t(Strings.SETTINGS_HELP_FIZZ_FORUM_TITLE).toString(),
        description: t(Strings.SETTINGS_HELP_FIZZ_FORUM_DESCRIPTION).toString(),
        link: getForum.value.link,
        url: getForum.value.url,
        visit: t(Strings.SETTINGS_HELP_FIZZ_VISIT).toString()
    }));
    const supportItem: IHelpItem = {
        iconComponent: SupportIcon,
        title: t(Strings.SETTINGS_HELP_FIZZ_SUPPORT_TITLE).toString(),
        description: t(Strings.SETTINGS_HELP_FIZZ_SUPPORT_DESCRIPTION).toString(),
        switch: {
            platformInstructions: t(Strings.SETTINGS_HELP_FIZZ_SUPPORT_SWITCH_FIRST_INSTRUCTIONS).toString(),
            qrCodeInstructions: t(Strings.SETTINGS_HELP_FIZZ_SUPPORT_SWITCH_SECOND_INSTRUCTIONS).toString(),
        }
    };

    onUnmounted(() => {
        clearHelp();
    });
</script>

<style lang="scss">
    @import url("styles.scss");
</style>
